import { toggleView as toggleDuplicateView } from './actions/duplicates';

import {
  changeRelatedSearch,
  changeSearchText,
  setTags,
  setCompaniesGroupFilterIds,
  setPeopleGroupFilterIds,
  setBackToLink,
  setPropertyIds,
  setRoles,
  changeCompanyPage,
  changeCompanySort,
  changePersonPage,
  changePersonSort,
  selectExcludeTags
} from './actions/query';

import { switchTab } from "./actions/ui";

import {
  arrayToString,
  booleanToString,
  stringToArray,
  stringToBoolean
} from "helpers/formatters/string_formats";

const queryParams = {
  tab: {
    action: value => value ? switchTab(value) : { type: null },
    selector: state => state.ui.currentTab
  },
  back_to: {
    action: setBackToLink,
    selector: state => state.query.backToLink
  },
  company_group: {
    action: setCompaniesGroupFilterIds,
    defaultValue: [],
    selector: state => state.query.companyGroupIds,
    stringToValue(string) {
      return stringToArray(string).map(value => !value || value === 'ungrouped' ? value : parseInt(value));
    },
    valueToString: arrayToString
  },
  duplicates: {
    action: value => toggleDuplicateView(!!value),
    defaultValue: false,
    selector: state => state.duplicates.viewActive,
    stringToValue: stringToBoolean,
    valueToString: booleanToString
  },
  exclude_tags: {
    action: selectExcludeTags,
    defaultValue: false,
    selector: state => state.query.excludeTags
  },
  people_group: {
    action: setPeopleGroupFilterIds,
    defaultValue: [],
    selector: state => state.query.peopleGroupIds,
    stringToValue(string) {
      return stringToArray(string).map(value => !value || value === 'ungrouped' ? value : parseInt(value));
    },
    valueToString: arrayToString
  },
  tags: {
    action: setTags,
    defaultValue: [],
    selector: state => state.query.tags || [],
    stringToValue: stringToArray,
    valueToString: arrayToString
  },
  propertyIds: {
    action: setPropertyIds,
    defaultValue: [],
    selector: state => state.query.propertyIds || [],
    stringToValue: stringToArray,
    valueToString: arrayToString
  },
  relatedSearch: {
    action: changeRelatedSearch,
    defaultValue: null,
    selector: state => state.query.relatedSearchId,
    stringToValue: value => Number(value) || undefined
  },
  roles: {
    action: setRoles,
    defaultValue: [],
    selector: state => state.query.roles,
    stringToValue: stringToArray,
    valueToString: arrayToString
  },
  search_text: {
    action: changeSearchText,
    defaultValue: '',
    selector: state => state.query.searchText || ''
  },
  person_page: {
    action: value => value ? changePersonPage(value) : { type: null },
    selector: state => state.query.personPage,
    stringToValue: value => Number(value)
  },
  company_page: {
    action: value => value ? changeCompanyPage(value) : { type: null },
    selector: state => state.query.companyPage,
    stringToValue: value => Number(value)
  },
  cs: { // Company sorting
    action: value => changeCompanySort(value || null),
    defaultValue: null,
    selector: state => state.query.companySort || null
  },
  ps: { // People sorting
    action: value => value ? changePersonSort(value) : { type: null },
    defaultValue: null,
    selector: state => state.query.personSort
  }
};

export default queryParams;
